import { render } from "./ZhiZaoKanBan3.vue?vue&type=template&id=2a8f3a27&scoped=true"
import script from "./ZhiZaoKanBan3.vue?vue&type=script&lang=js"
export * from "./ZhiZaoKanBan3.vue?vue&type=script&lang=js"

import "./ZhiZaoKanBan3.vue?vue&type=style&index=0&id=2a8f3a27&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8f3a27"]])

export default __exports__